<template>
  <v-layout class="subheading">
    <v-btn
      data-testid="return-to-select-unit-btn"
      class="return-to-select-unit-btn mr-3"
      v-show="updateNeeded && currentStep > 0"
      @click="toSelect"
      :disabled="!recording"
    >
      <v-icon class="mr-2">domain</v-icon>
      Return to Select Unit
    </v-btn>
    <v-btn
      data-testid="return-to-rental-options-btn"
      class="return-to-rental-options-btn mr-3"
      v-show="currentStep > 1"
      @click="toOptions"
      :disabled="!recording"
    >
      <v-icon class="mr-2">shopping_cart</v-icon>
      Return to Rental Options
    </v-btn>
    <v-btn
      data-testid="return-to-lease-info-btn"
      class="return-to-lease-info-btn mr-3"
      v-show="currentStep > 2"
      @click="toLeaseInfo"
      :disabled="!recording"
    >
      <v-icon class="mr-2">info_outline</v-icon>
      Return to Lease Info
    </v-btn>
    <v-btn
      data-testid="return-to-move-in-instructions-btn"
      class="return-to-move-in-instructions-btn mr-3"
      v-show="currentStep > 3"
      @click="toMoveInInstructions"
      :disabled="!recording"
    >
      <v-icon class="mr-2">follow_the_signs</v-icon>
      Return to Move-In Instructions
    </v-btn>
    <v-btn
      data-testid="return-to-add-merchandise-btn"
      class="return-to-add-merchandise-btn mr-3"
      v-show="currentStep > 4"
      @click="toAddMerchandise"
      :disabled="!recording"
    >
      <v-icon class="mr-2">lock</v-icon>
      Return to Add Merchandise
    </v-btn>
    <v-btn
      data-testid="return-to-payment-options-btn"
      class="return-to-payment-options-btn"
      v-show="currentStep > 5"
      @click="toPayment"
      :disabled="!recording"
    >
      <v-icon class="mr-2">payment</v-icon>
      Return to Payment Options
    </v-btn>
  </v-layout>
</template>

<script>
import { EventBus } from "@/Event";

export default {
  props: {
    currentStep: {
      type: [Number, String],
      default: 1
    },
    updateNeeded: {
      type: Boolean
    }
  },
  methods: {
    toSelect() {
      EventBus.$emit("toSelect");
    },
    toOptions() {
      EventBus.$emit("toOptions");
    },
    toLeaseInfo() {
      EventBus.$emit("toLeaseInfo");
    },
    toMoveInInstructions() {
      EventBus.$emit("toMoveInInstructions");
    },
    toAddMerchandise() {
      EventBus.$emit("toAddMerchandise");
    },
    toPayment() {
      EventBus.$emit("toTakePayment");
    }
  },
  computed: {
    recording() {
      return this.$store.state.call.recording;
    }
  }
};
</script>
